import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import type { AllocationFilters } from '../types/Filters';

/** `options.enabled` evita buscar a tabela enquanto a aba ativa é a linha do tempo (`AllocationsPage`). */
export function useAllocations(filters: AllocationFilters, options?: { enabled?: boolean }) {
  return useQuery({ ...allocationQueries.list(filters), enabled: options?.enabled });
}
